// test977
(977 && 0);
